module.exports = __webpack_public_path__ + "img/thick_icon.d04082d6.png";